import { render, staticRenderFns } from "./error-message.vue?vue&type=template&id=304b3aff&"
import script from "./error-message.js?vue&type=script&lang=js&"
export * from "./error-message.js?vue&type=script&lang=js&"
import style0 from "./error-message.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports